var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSnacks = function SvgSnacks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "snacks_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#snacks_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.322 10.182a.55.55 0 0 1-.4-.172.55.55 0 0 1-.173-.4q0-2.155 1.914-3.37T12 5.025t6.337 1.215q1.914 1.215 1.913 3.37a.55.55 0 0 1-.172.4.55.55 0 0 1-.4.172zm.367-.917H19.31q-.138-1.558-1.936-2.44-1.8-.883-5.375-.883t-5.375.883-1.936 2.44m-.94 4.126q0-.16.115-.31a.65.65 0 0 1 .32-.217q.573-.138.997-.494.424-.354 1.318-.354 1.077 0 1.513.458t1.238.458 1.237-.458T12 12.016t1.512.458 1.238.458 1.226-.458q.425-.458 1.478-.458.894 0 1.353.354.457.356 1.008.494a.65.65 0 0 1 .32.217q.115.15.115.31 0 .206-.149.32a.44.44 0 0 1-.332.092q-.78-.137-1.134-.504-.355-.366-1.089-.367-.802 0-1.26.459-.459.458-1.536.458t-1.513-.458q-.435-.459-1.237-.459t-1.238.459-1.512.458-1.513-.458-1.238-.459q-.71 0-1.1.367t-1.169.504a.44.44 0 0 1-.332-.091.38.38 0 0 1-.149-.321m1.49 5.959q-.642 0-1.066-.424T3.75 17.86v-.688q0-.618.435-1.054.435-.435 1.055-.435H18.76q.619 0 1.054.435t.435 1.054v.688q0 .642-.423 1.066-.424.424-1.066.424zm0-.917H18.76a.56.56 0 0 0 .412-.16.56.56 0 0 0 .16-.413v-.688a.56.56 0 0 0-.16-.412.56.56 0 0 0-.412-.16H5.239a.56.56 0 0 0-.413.16.56.56 0 0 0-.16.412v.688q0 .253.16.412.16.16.413.16m0-1.834h-.573 14.668H5.239"
  }))));
};
export default SvgSnacks;